<web-design-system-modal [headline]="'lombard.cancel.headline' | transloco" (dismiss)="modal.close()">
  {{ 'lombard.cancel.body' | transloco }}
  <web-components-transaction-auth [payload]="authorizePayload" (transactionResult)="handleTransactionAuthorization($event)" />
</web-design-system-modal>
